<mat-form-field class="full-width" appearance="standard">
	<mat-label>Vendor</mat-label>
	<input type="text" #vendor matInput [formControl]="vendorSearch" [matAutocomplete]="vendors" appSelectOnFocus>
	<mat-autocomplete #vendors="matAutocomplete" (optionSelected)="selectVendor($event)" [displayWith]="displayFn">
		<mat-option *ngFor="let vendor of filteredItems" [value]="vendor" >
			<b>{{vendor.supplierid}}</b> - {{ vendor.suppname }}
		</mat-option>
	</mat-autocomplete>
</mat-form-field>
